import { ErrorList, WarningList } from '@/app/assets/components/table/columns/basicInfoColumn/InfosList';
import { Stack, StackProps } from '@mantine/core';
import { ModelDescriptor } from '../../../../components/supportTicket/types';

const areErrorsOrWarningsPresent = (errors: string[] | undefined, warnings: string[] | undefined) => {
  return { areErrors: (errors ?? []).length > 0, areWarnings: (warnings ?? [])?.length > 0 };
};

export function AssetInfos({
  errors,
  warnings,
  assetDescription,
  ...props
}: {
  errors: string[] | undefined;
  warnings: string[] | undefined;
  assetDescription?: ModelDescriptor;
} & StackProps) {
  const { areErrors, areWarnings } = areErrorsOrWarningsPresent(errors, warnings);

  if (!areErrors && !areWarnings) {
    return null;
  }

  return (
    <Stack gap='sm' {...props}>
      {areErrors ? <ErrorList errors={errors ?? []} assetDescription={assetDescription} w='96%' /> : null}
      {areWarnings ? <WarningList warnings={warnings ?? []} w='96%' /> : null}
    </Stack>
  );
}
